import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { useMediaQuery } from "react-responsive";
import { ChartWrapper } from "../components/ChartWrapper";
import { formatNumber } from "../../utils/number";

const COLORS = {
  Correct: "#22c55e",
  Incorrect: "#ef4444",
  Unattempted: "#9ca3af",
};

// 🔥 Custom Legend (clean + aligned)
const renderLegend = (props) => {
  const { payload } = props;

  if (!payload || !payload.length) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        width: "fit-content",
        flexWrap: "wrap",
        marginTop: "8px",
      }}
    >
      {payload.map((entry, index) => {
        const value = entry.payload.value;

        return (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "13px",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            {/* color dot */}
            <span
              style={{
                width: 14,
                height: 10.5,
                background: entry.color,
              }}
            />

            {/* label */}
            <span
              style={{
                textTransform: "capitalize",
                fontWeight: 600,
                color: entry.color,
              }}
            >
              {entry.value}
            </span>

            {/* value */}
            <span style={{ fontWeight: 700 }}>{formatNumber(value)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default function QuestionAttemptsPie({ data = [], loading }) {
  const isSmall = useMediaQuery({ query: "(max-width: 472px)" });

  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <ChartWrapper
      title="Question Attempts"
      subtitle="Correct vs Incorrect vs Unattempted"
      loading={loading}
    >
      <div style={{ width: "100%", height: "100%", position: "relative" }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart
            margin={{
              top: 0,
              bottom: 20, // space for legend
            }}
          >
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="45%" // 🔥 push upward for legend space
              innerRadius={isSmall ? 55 : 90}
              outerRadius={isSmall ? 90 : 130}
              paddingAngle={2}
              labelLine={false}
              isAnimationActive
            >
              {data.map((entry, index) => (
                <Cell key={index} fill={COLORS[entry.name] || "#ccc"} />
              ))}
            </Pie>

            <Tooltip
              formatter={(value, name) => [`${value}`, name]}
              contentStyle={{
                borderRadius: "8px",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />

            <Legend width={"fit-content"} content={renderLegend} verticalAlign="bottom" />
          </PieChart>
        </ResponsiveContainer>

        {/* 🔥 Center Total */}
        <div
          style={{
            position: "absolute",
            top: "40%", // aligned with pie center
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: "#111827",
            }}
          >
            {formatNumber(total)}
          </div>
          <div
            style={{
              fontSize: 12,
              color: "#6b7280",
            }}
          >
            Total Questions
          </div>
        </div>
      </div>
    </ChartWrapper>
  );
}
